import { createIcon } from '@chakra-ui/react';

export const FlagIcon = createIcon({
  displayName: 'FlagIcon',
  path: (
    <>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none">
        <path d="M3.43359 1.33334V14.6667" stroke="#6E6789" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M3.43359 2.66666H10.9003C12.7003 2.66666 13.1003 3.66666 11.8336 4.93332L11.0336 5.73332C10.5003 6.26666 10.5003 7.13332 11.0336 7.59999L11.8336 8.39999C13.1003 9.66666 12.6336 10.6667 10.9003 10.6667H3.43359" stroke="#6E6789" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    </>
  ),
});
